<template>
    <div class="employee-tab-inner investment-align-mobile" >

          <!-- Abdullah responsive added mx-3  -->
        <div class="row no-gutters py-2 mb-3 ml-3 custom-mobile-left-side-alignment-margin">
          <div class="col-md-10 col-sm-12" >
            <h4 class="atlhr-dashboard-title mt-10">
                Investments
                <span>
                    <a v-bind:href="$api_url">Dashboard</a>
                    / Tax Reducers / Investments
                </span>
            </h4>
          </div>
        </div>
        <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
            <!-- Abdullah responsive added mx-3  -->
            <div class="clearfix company-form-container ml-3 dashboard-mobile-margin-right">
            <div class="p-3 employee-investment-wrapper">

                <div class="" >

                    <div class="row no-gutters py-2 mb-3">
                        <div class="col-sm-5 company-form-box-title">Investment Details</div>
                        <div class="col-sm-7 cursor-pointer text-right company-form-box-title">
                            <select id="year" v-model="year" name="year" class="form-control custom-select investment-select">
                                    <option v-for='pyr in payrunyears'  :value='pyr.value'>{{ pyr.text }}</option>
                            </select>
                            <button class="btn btn-block btn-secondary tab-button add-investment" @click="addNew()">Add Investment</button>
                        </div>
                    </div>

                    <div class="row col-md-12 mb-4 no-margin px-0" v-if="year != null && Object.keys(investments[year]).length > 0">
                        <div class="investment-total-text-box">Total Investment Amount Recorded for {{investments[year].fiscal_year}} : <span style="float:right;">&nbsp;&nbsp; &#2547 <template v-if="decimal_setting == 'no'">{{moneyFormat(Math.round(investments[year].total))}}</template><template v-else>{{moneyFormat(investments[year].total)}}</template> </span></div>
                    </div>

                    <!-- added total approved amount for investment -afrin -->
                    <div class="row col-md-12 mb-4 no-margin px-0"
                        v-if="year != null && Object.keys(investments[year]).length > 0">
                        <div class="investment-total-text-box">Total Approved Investment for
                            {{ investments[year].fiscal_year }} : <span style="float:right;">&nbsp;&nbsp; &#2547
                                <template v-if="decimal_setting == 'no'">{{
                                    moneyFormat(Math.round(investments[year].total_approved)) }}</template><template
                                    v-else>{{ moneyFormat(investments[year].total_approved) }}</template> </span>
                        </div>
                    </div>
                    <!-- end added total approved amount for investment -afrin -->

                    <div class="employee-table-wrapper table-sticky-height" :class="{'no-overflow': investments[year].details.length < 1}" v-if="year != null">
                        <table class="employee-list-table dataTable table-overflow table-sticky ess-custom-table">
                            <thead>
                                <tr class="table-head ">
                                    <td>  <label class="custom-label"><span>Fiscal Year</span></label> </td>
                                    <td><label class="custom-label "><span>Type of Investment</span></label> </td>
                                    <td> <label class="custom-label "><span>Investment Amount</span></label>   </td>
                                    <td>  <label class="custom-label "><span>Document</span></label>  </td>
                                        <td> <label class="custom-label "><span>Status</span></label> </td>
                                    <td>  <label class="custom-label "><span>Last Activity <span class="custom-date-indicator">(YYYY-MM-DD)</span></span></label>  </td>
                                    <td> <label class="custom-label "><span>Action</span></label> </td>
                                </tr>
                            </thead>
                            <template v-if="year != null">
                                <tbody>
                                    <tr class="hover-bg table-row" v-for="investment_details in investments[year].details" :key="investment_details.id">
                                        <td class="cursor-pointer trz_relative">  <label class="mb-0 custom-label">{{investment_details.fiscal_year}}</label></td>
                                        <td class="cursor-pointer trz_relative">{{investment_types_list[investment_details.type].text}}</td>
                                        <td class="cursor-pointer trz_relative text-right">
                                            <template v-if="decimal_setting == 'no'">{{moneyFormat(Math.round(investment_details.given_investment_ammount))}}</template><template v-else>{{moneyFormat(investment_details.given_investment_ammount)}}</template>
                                        </td>
                                        <td class="cursor-pointer trz_relative">
                                            <div class="text-uppercase align-self-center text-center" v-if="investment_details.uploaded_file">
                                                <!-- <b-link :href="$api_url+'/images/employee/'+ investment_details.company_id + '/' + investment_details.uploaded_file">
                                                    <img :src="$api_url+'/images/download_image.png'"  class="" />
                                                </b-link> -->
                                                <b-link @click="downloadFileContent('/images/employee/'+ investment_details.company_id + '/' + investment_details.uploaded_file)">
                                                    <img :src="$api_url+'/images/download_image.png'"  class="" />
                                                </b-link>
                                            </div>
                                        </td>                                        
                                        <td class="cursor-pointer trz_relative">
                                            <div class=""><template v-if="investment_details.status == 1"><b-icon icon="check-circle-fill" variant="success" class="mr-2"></b-icon></template><template v-else><b-icon icon="dash-circle-fill" variant="warning" class="mr-2"></b-icon></template>{{ statusMap[investment_details.status] }}</div>
                                        </td>
                                        <td class="cursor-pointer trz_relative">
                                            <template v-if="investment_details.updated_at != null">{{ formatMe(investment_details.updated_at) }}</template>
                                            <template v-else>{{ formatMe(investment_details.created_at) }}</template>
                                        </td>
                                        <td class="cursor-pointer trz_relative">

                                            <div class=" text-right clearfix align-self-center" > <!-- Mustafijur: 18-05-2026 Deleted col-sm -->
                                                <template v-if="canModifyInvestment(investment_details, investments[year].approver_enabled)">
                                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                        <b-button-toolbar class="">
                                                            <b-button-group class="">
                                                                <b-button title="Edit Investment" @click="editInvestment(investment_details.id)">
                                                                    <i class="fa fa-pencil-alt"></i> Edit
                                                                </b-button>
                                                                <b-button title="Delete Investment" @click="deleteInvestment(investment_details.id)">
                                                                    <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                                </b-button>
                                                            </b-button-group>
                                                        </b-button-toolbar>
                                                    </div>
                                                </template>

                                                <div class="text-center float-right" v-else title="This investment can't be edited or deleted since a payrun has been approved after this was listed." v-b-tooltip placement="right">
                                                    <b-icon icon="info-circle"></b-icon>
                                                </div>
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <template v-else>
                                <tr class="hover-bg table-row">
                                    <td class="cursor-pointer trz_relative text-center" colspan="7">No Investment found</td>
                                </tr>
                            </template>

                        </table>
                    </div>
                    <div class="employee-table-wrapper table-sticky-height" v-else>
                        <table class="employee-list-table dataTable table-overflow table-sticky ess-custom-table">
                            <thead>
                                <tr class="table-head ">
                                    <td>  <label class="custom-label"><span>Fiscal Year</span></label> </td>
                                    <td><label class="custom-label "><span>Type of Investment</span></label> </td>
                                    <td> <label class="custom-label "><span>Investment Amount</span></label>   </td>
                                    <td>  <label class="custom-label "><span>Document</span></label>  </td>
                                    <td>  <label class="custom-label "><span>Last Activity <span class="custom-date-indicator">(YYYY-MM-DD)</span></span></label>  </td>
                                    <td> <label class="custom-label "><span>Action</span></label> </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row">
                                    <td class="cursor-pointer trz_relative text-center" colspan="7">No Investment found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Abdullah 19-05-26 added title  -->
                <b-modal id="bv-modal-example" size="lg" :modal-class="'w-600'" hide-footer :title="add_investment_title">
                    <b-form @submit.stop.prevent="onSubmit">
                        <div class="clearfix">
                            <div class="col-md-12">

                                <input type="hidden" v-model="fdata.id" name="id">
                                <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field" label-for="fiscal_year">
                                    <!--<b-form-input id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" readonly></b-form-input>-->
                                    <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" :options="fiscal_years" v-validate="{ required: true }" :state="validateState('fiscal_year')" aria-describedby="gender-feedback" data-vv-as="Fiscal Year"></b-form-select>
                                    <b-form-invalid-feedback id="fiscal_year-feedback">{{ veeErrors.first('fiscal_year') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="investment_type_index-group" label="Investment Type" class="required-field" label-for="investment_type_index">
                                <b-form-select id="investment_type" name="investment_type" v-model="fdata.investment_type" :disabled="disabled" v-validate="{ required: true }" :options="investment_types" :state="validateState('investment_type')" aria-describedby="gender-feedback" data-vv-as="Investment Type"></b-form-select>
                                    <b-form-invalid-feedback id="investment_type-feedback">{{ veeErrors.first('investment_type') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="given_investment_ammount-group" label="Investment Amount ( ৳ )" class="required-field" label-for="given_investment_ammount">
                                    <b-form-input id="given_investment_ammount" name="given_investment_ammount" v-model="fdata.given_investment_ammount" v-validate="{ required: true , decimal:2, regex: /^(?=.*[0-9])\d+(\.\d+)?$/ }" :state="validateState('given_investment_ammount')" aria-describedby="given_investment_ammount-feedback" data-vv-as="Amount"></b-form-input>
                                    <b-form-invalid-feedback id="given_investment_ammount-feedback">{{ veeErrors.first('given_investment_ammount') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group  id="remarks-group" label="Remarks" class="" label-for="remarks">
                                    <b-form-textarea id="remarks" name="remarks" rows="3" max-rows="6" no-resize v-model="fdata.remarks"></b-form-textarea>
                                </b-form-group>

                                <div class="row">
                                    <div class="col-sm-12">
                                    <b-form-group id="uploaded_file-group" label="Upload File" label-for="uploaded_file">
                                        <b-form-file id="uploaded_file" v-model="uploaded_file" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..."
                                        @change="checkFileType($event , 'uploaded_file' , ['.jpg','.png','.gif','.pdf'])"
                                        ref="uploaded_file"
                                        drop-placeholder="Drop file here..." aria-describedby="uploaded_file-feedback" data-vv-as="Upload File"></b-form-file>
                                    </b-form-group>
                                    </div>
                                    <div class="col-sm-2 align-self-center mt-2 text-center" v-if="fdata.uploaded_file">
                                        <!-- <b-link :href="$api_url+'/images/employee/'+ fdata.company_id + '/' + fdata.uploaded_file" target="_blank">
                                            <img :src="$api_url+'/images/download_image.png'"  class="" />
                                        </b-link> -->
                                        <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + fdata.uploaded_file)">
                                            <img :src="$api_url+'/images/download_image.png'"  class="" />
                                        </b-link>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="mt-4 ml-4 mb-4 clearfix text-center" style="margin-right: 18px;">
                            <b-button class="btn border rounded bg-light py-1 px-5 mt-4 ml-2 btn-primary" type="submit" :disabled="isSubmitting">{{ isSubmitting ? 'Saving...' : 'Submit' }}</b-button>
                            <b-button class="btn border rounded bg-light py-1 px-5 mt-4 ml-2 btn-primary custom-primary d-none" @click="resetForm()">Reset</b-button>
                        </div>

                    </b-form>
                </b-modal>
            </div>

            </div>
            </div>
        </template>
        <template v-else>
                <lock-template></lock-template>
        </template>
</div>

</template>
<script>
    import moment from 'moment';

    export default{

        mounted() {
            //console.log('investments info started..');
            //console.log(this.employee_id);
        },
        props: ['flg'],
        data(){

            return {
                itabIndex : 0,
                fiscal_year : this.getCurrentFinancialYear(),
                investments : [],
                year_investments : [],
                show_year_investments : false,
                showoverlay_list : false,
                successmsg:null,
                errormsg:[],
                fdata: {fiscal_year: this.getCurrentFinancialYear(), given_investment_ammount:null, id:null , type:null,investment_type_index:null,},
                uploaded_file : null,


                isSubmitting: false,

                fiscal_years: this.$fiscal_year_options,

                decimal_setting: 'yes',
                investment_types: [],
                investment_types_list: [],
                disabled:false,
                permission : 0,
                // year:this.getCurrentFinancialYear(),
                year:null,
                payrunyears:[
                    { value: null, text: "Select Fiscal Year" },
                ],
                // Abdullah 19-05-26 added this
                add_investment_title : 'Add Investment',
                statusMap: {
                    0: 'Pending',
                    1: 'Approved'
                }

            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('YYYY-MM-DD hh:mm:ss A');
            },
            moneyFormat(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(this.decimal_setting == 'yes' || this.decimal_setting == '')
                    if(money.indexOf(".")<0)
                        money = money+'.00';
                return money;
            },
            getInvestments: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.year_investments = [];
                this.show_year_investments = false;
                axios.get(this.$api_url+'/front/investment/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.investments = response.data;
                    this.tabIndex = 1;

                    this.payrunyears = [];
                    this.year = null;
                    this.payrunyears.push({value: null,text: 'Select Fiscal Year'});
                    //Object.values(this.investments).forEach(val => this.payrunyears.push({value: val.fiscal_year,text: val.fiscal_year}));
                    Object.values(this.investments).forEach(val => {
                        this.payrunyears.push({value: val.fiscal_year,text: val.fiscal_year});
                        if(val.fiscal_year == this.getCurrentFinancialYear())
                        {
                            this.year = this.getCurrentFinancialYear();
                        }
                    });

                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            getInvestmentTypes: function()
            {
                if(!this.checkNet()) return false;

                axios.get(this.$api_url+'/front/investment/type' , {
                    params: {

                    }
                }).then(function(response){

                    this.investment_types = response.data;
                    this.investment_types_list = response.data;




                }.bind(this));
            },
            showInvestment:function(x)
            {
                this.fiscal_year = x;
                this.year_investments = this.investments[x].details;
                this.show_year_investments = true;
            },
            addNew()
            {
                this.resetForm();
                this.fdata = {id:null};
                // Abdullah 19-05-26 added this
                this.add_investment_title = 'Add Investment';
                this.$bvModal.show('bv-modal-example');

            },
            editInvestment:function(x)
            {
                if(!this.checkNet()) return false;
                // Abdullah 19-05-26 added this
                this.add_investment_title = 'Edit Investment';
                let currentObj = this;
                axios.get(this.$api_url+'/front/investment/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    if(this.fdata.remarks == 'null')
                        this.fdata.remarks = '';

                    this.successmsg = null;
                    this.itabIndex = 0;
                    this.fdata.investment_type = response.data.type;
                    this.$bvModal.show('bv-modal-example');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});



            },

            deleteInvestment:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm if you want to delete this entry.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        this.fdata = {id:null};
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/front/investment/delete', formData).then(function(response){

                            if(response.data.status == true)
                            {
                                this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.getInvestments();
                            }
                            this.showoverlay_list = false;

                        }.bind(this)).catch(function (error){ currentObj.showoverlay_list = false; currentObj.serverError(error);});
                    }
                })
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               //this.fdata = {fiscal_year:this.getCurrentFinancialYear(), allow_manual_investment_rebate:null, given_investment_ammount:null, investment_type:null,};
               this.fdata.fiscal_year = null;
               this.fdata.allow_manual_investment_rebate = null;
               this.fdata.given_investment_ammount = null;
               this.fdata.investment_type = null;
               this.uploaded_file = null;

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmit(e)
            {
                if (this.isSubmitting) return; // prevent double click
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.isSubmitting = true;
                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        console.log(`${key}: ${value}`);
                    }

                    if(this.uploaded_file)
                       formData.append('form_uploaded_file', this.uploaded_file);

                    axios.post(this.$api_url+'/front/investment/save', formData, config)
                        .then(function (response)
                        {
                            this.resetForm();
                            this.fdata = {id:null};
                            this.getInvestments();
                            this.itabIndex = 1;

                            this.$bvToast.toast("Saved", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.$bvModal.hide('bv-modal-example');

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                            //currentObj.errormsg = error.response.data.errors;
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });
                });
            },

            get_decimal_settings: function()
            {
              axios.get(this.$api_url+'/front/decimal-settings')

              .then(function (response) {
                this.decimal_setting = response.data;
              }.bind(this));
            },

            // Approver update
            canModifyInvestment(investment_details, approver_enabled) {
                return approver_enabled == 1
                    ? investment_details.status == 0
                    : investment_details.flg == 1;
            },
            // Approver update

        },
        created: function(){
            this.getInvestments();
            this.getInvestmentTypes();
            this.get_decimal_settings();
        }
    }
</script>

